import React from 'react';


export default class Buttons extends React.Component {
  constructor(props) {
    super(props);
    let def = this.props.default ? this.props.default : [];
    let val = this.props.value ? this.props.value : def;
    this.state = {
      options: [],
      value: val
    };
    this.handleChange = this.handleChange.bind(this);
    this.field = this.field.bind(this);
  }

  componentDidUpdate(prevProp, prevState){
    if((prevProp.refs !== this.props.refs)||(prevProp.value !== this.props.value)){
      this.setState({
        value: this.props.value
      })
    }
  }

  componentDidMount(){
    let options = this.props.options || [];
    if(!Array.isArray(options))
      options = options.split(',')
    this.setState({
      options: options
    })
  }

  handleChange(e) {
    // console.log(e)
    // console.log(e.target.value)
    let val = this.state.value;
    if(val.includes(e.target.value)){
      val = val.filter(x => x!= e.target.value);
    }else{
      if(this.props.multiple === true){
        val.push(e.target.value)
      }else{
        val = [e.target.value];
      }
    }
    this.setState({
      value: val
    })
    if(this.props.callback !== null){
      this.props.callback({
        field: this.props.name,
        value: val
      })
    }
    e.preventDefault();
  }

  field(){
    let propOp = this.state.options;
    let options = propOp.map((val, index) => {
      let out = val;
      if(this.props.hasOwnProperty('output')){
        out = (this.props.output.hasOwnProperty(val)) ? this.props.output[val] : val;
        out = (this.props.output.hasOwnProperty(index)) ? this.props.output[index] : out;
      }
      let active = (this.state.value.includes(val)) ? 'primary on' : 'secondary off';
      return (
        <div key={"bt"+index} className={this.props.btnCntClass}>
          <button type="button"
                className={"btn btn-"+active+" b-"+val+" "+this.props.buttonsClass}
                key={"sel-"+index}
                value={val} onClick={this.handleChange}>{out}</button>
        </div>
      )
    });
    return(
      <>
        {options}
      </>
    )
  }

  render() {
    return (

          <>{this.field()}</>

    );
  }
}
